import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import Box from '../../profilePage/components/Box.jsx';
import BoxesRow from '../../profilePage/components/BoxesRow.jsx';
import { hardwareProducts } from '../../../../modules/customer/index.js';
import ActionButton from '../../../components/ActionButton.jsx';
import { customer } from '../../../../modules/index.js';
import { push } from 'connected-react-router';
import SearchResult from './SearchResult.jsx';

class Serials extends React.Component {

    // Actions 
    update = (agreementDetailsId, key, serial, original) => {
        this.props.updateSerial(agreementDetailsId, key, serial);
    }

    save = (agreementDetailsId) => {
        this.props.saveSerial(this.props.customerId, agreementDetailsId, this.props.getHardwareDetails(agreementDetailsId));
        this.props.resetSearch();
        this.props.saveStart();
        setTimeout(this.onSave, 2000);
    }

    onSave = () => {
        this.props.saveStop();
        this.props.loadHardware(this.props.customerId);
    }

    search = (agreementDetailsId, key) => {
        const serial = this.props.getCurrentSerial(agreementDetailsId, key);
        if (serial) this.props.searchSerial(serial);
    }

    isSearchActive = (agreementDetailsId, key) => !!this.props.getCurrentSerial(agreementDetailsId, key);
    isWorking = () => this.props.isLoading || this.props.isSaving;

    // Validation
    isValidGroup = (group) => this.getErrorMessages(group).length === 0;
    isMatchingTechnical = (product, result) => result.technicalProductId === product.id; // Matching technical product id
    isValidStatus = (result) => result.status && result.status.id === 1; // 'In Stock';
    isSerialLoaded = (agreementDetailsId, key) => { 
        const serial = this.props.getCurrentSerial(agreementDetailsId, key);
        return serial && this.props.isSearchLoaded(serial);
    }

    getErrorMessages = (group) => {
        let errors = [];
        for (let key in group.products) {
            const product = group.products[key];
            const agreementDetailsId = product.commercialProductAgreementDetailId;
            const serial = this.props.getCurrentSerial(agreementDetailsId, key);
            if (!serial) errors.push('Serial missing');
            const result = this.props.getSearchResult(serial);
            if (!result) errors.push(`${serial} - Utstyr ikke funnet`);
            if (result && !this.isMatchingTechnical(product, result)) errors.push(`${serial} - Ugyldig utstyrstype`);
            if (result && !this.isValidStatus(result)) errors.push(`${serial} - Status må være 'In Stock'`);
        } 
        return errors;
    }

    shouldDisplayMessages = (group) => group.products.every((product, key) => this.isSerialLoaded(product.commercialProductAgreementDetailId, key));


    getMessages = (group) => this.shouldDisplayMessages(group)?
        <span className="message error">{this.getErrorMessages(group).join("; ")}</span>:
        <span className="message">Skriv serienummer og trykk på 'Søk'</span>

    getName = (group) => group.id + "  - " + group.products.map(x => x.name).join(" + ");

    getProduct = (product, key) => product.serialNumber? 
        this.getProductWithSerial(product, key):
        this.getProductWithoutSerial(product, key);

    getProductWithSerial = (product, key) => <div className="device">
        <div className="description product-box">
            Product {product.name} already has serial number {product.serialNumber} assigned. Changing is not supported at the moment
            </div>
        </div>

    getProductWithoutSerial = (product, key) => <div key={'serial_'+key} className="device">
        <div className="row">
            <div className="col-md-4">
                <div className="description product-box">
                    <h4 className="product-name">{product.name}</h4>
                    <b>Sn:</b> {product.serialNumber|| "Har ikke serienummer"} <b>Status:</b> {product.status}<br />
                </div>
            </div>
            <div className="col-md-4">
                <input 
                    className="serial-input" 
                    type="text" 
                    placeholder="Søk serienummer"
                    onChange={(e) => this.update(product.commercialProductAgreementDetailId, key, e.target.value, product.serialNumber)} 
                />
                <ActionButton 
                    action={() => this.search(product.commercialProductAgreementDetailId, key)} 
                    active={this.isSearchActive(product.commercialProductAgreementDetailId, key)}
                    title="Søk" 
                />
            </div>
            <div className="col-md-3">
                <SearchResult serialNumber={this.props.getCurrentSerial(product.commercialProductAgreementDetailId, key)} />
            </div>
        </div>
    </div>;



    getGroup = (group, key) => <div className={'group_'+key} className="group">
        <h4 className="title">{this.getName(group)}</h4>
        {group.products && group.products.map((product, key) => this.getProduct(product, key))}
        <div className="text-right">
            {this.getMessages(group)}
            <ActionButton 
                action={() => this.save(group.id)} 
                active={this.isValidGroup(group)}
                title="Bind utstyr" 
            />
        </div>
    </div>

    render = () => <BoxesRow>
        <Box label="Serienumre" isLoading={this.isWorking()} className="serials">
            {this.props.groups.map((product, key) => this.getGroup(product, key))}
            {this.props.groups.length === 0 && <div className="alert alert-warning">Ingen produkter</div>}
        </Box>
    </BoxesRow>

}

const mapStateToProps = (state, props) => ({
    customerId: customer.profile.selectors.getCustomerID(state),
    isLoading: hardwareProducts.selectors.isLoading(state),
    isSaving: hardwareProducts.selectors.isSaving(state),
    groups: hardwareProducts.selectors.getGroupedProducts(state),
    getHardwareDetails: (agreementDetailsId) => hardwareProducts.selectors.getHardwareDetails(state, agreementDetailsId),
    getCurrentSerial: (agreementDetailsId, key) => hardwareProducts.selectors.getCurrentSerial(state, agreementDetailsId, key),
    getSearchResult: (serialNumber) => hardwareProducts.selectors.getSearchResult(state, serialNumber),
    isSearchLoaded: (serialNumber) => hardwareProducts.selectors.isSearchLoaded(state, serialNumber)
});

const mapDispatchToProps = (dispatch, props) => ({
    updateSerial: (agreementDetailsId, key, serial) => dispatch(hardwareProducts.actions.updateSerial(agreementDetailsId, key, serial)),
    saveSerial: (customerId, agreementDetailsId, hardwareDetails) => dispatch(hardwareProducts.actions.saveSerial(customerId, agreementDetailsId, hardwareDetails)),
    redirect: (customerId) => dispatch(push("/customer/"+ customerId)),
    searchSerial: (serialNumber) => dispatch(hardwareProducts.actions.searchSerial(serialNumber)),
    resetSearch: () => dispatch(hardwareProducts.actions.resetSearch()),
    loadHardware: (id) => dispatch(hardwareProducts.actions.fetchHardwareProductsList(id)),
    saveStart: () => dispatch(hardwareProducts.actions.saveStart()),
    saveStop: () => dispatch(hardwareProducts.actions.saveStop())
});

export default connect(mapStateToProps, mapDispatchToProps)(Serials);